'use client'
import { createTheme, type ThemeOptions } from '@mui/material/styles'
import { NextLinkBehaviour } from '@/app/_components/NextLinkBehaviour'

declare module '@mui/material/styles' {
	interface PaletteColor {
		altern?: string
	}
	interface SimplePaletteColorOptions {
		altern?: string
	}
}

declare module '@mui/material/Typography' {
	interface TypographyOwnProps {
		label?: string
	}
}

export const lightTheme = createTheme({
	palette: {
		mode: 'light',
		primary: { main: '#0358A3', light: '#92e1fe', altern: '#0473d6' },
		secondary: { main: '#F58320', dark: '#c26418', contrastText: '#fff' },
		cancel: { main: '#333' },
	},
	components: {
		MuiLink: { defaultProps: { component: NextLinkBehaviour } },
		MuiButtonBase: { defaultProps: { LinkComponent: NextLinkBehaviour } },
		MuiButton: { defaultProps: { size: 'small' } },
		MuiTableCell: { defaultProps: { size: 'small' }, styleOverrides: { root: { lineHeight: 1.2, fontSize: 15 } } },
		MuiTextField: { defaultProps: { variant: 'outlined', size: 'small' } },
		MuiSelect: { defaultProps: { variant: 'outlined', size: 'small' } },
		MuiAccordionSummary: { styleOverrides: { root: { color: 'black !important' } } },
		MuiInputBase: {
			defaultProps: { size: 'small' },
			styleOverrides: {
				root: {
					'& input[type=number]::-webkit-outer-spin-button, input[type=number]::-webkit-inner-spin-button': {
						WebkitAppearance: 'none',
						margin: 0,
					},

					'& input[type=number]': {
						MozAppearance: 'textfield',
					},
				},
			},
		},
		MuiListItem: { defaultProps: { dense: true } },
	},
	typography: {
		h5: {
			lineHeight: 'unset',
		},
		h4: {
			lineHeight: 'unset',
		},
	},
} as ThemeOptions)

export const SIDEBAR_WIDTH = 240 as const
export const TOP_BAR_HEIGHT = 64 as const

/** Solid primary header row shared by the app's data tables (see PartMasterManagerModal). */
export const TABLE_HEADER_CELL_SX = { fontWeight: 600, bgcolor: 'primary.main', color: 'primary.contrastText' } as const
